var exports = {
  "k": "x04b3a21e--a419f0--promotion-item",
};

module.exports = exports;
